window.reviews = [

    {
        "name": "Lina Schäfer",
        "rating": 5,
        "gender": "female",
        "review": "Schneller Versand, alles super.",
        "date": "2025-04-02"
    },
    {
        "name": "Sofía Delgado",
        "rating": 4,
        "gender": "female",
        "review": "Lieferung dauerte diesmal 5 Tage, doch dank freundlichem Support alles problemlos geklärt.",
        "date": "2025-04-04"
    },
    {
        "name": "Małgorzata Kowalczyk",
        "rating": 5,
        "gender": "female",
        "review": "Sehr solides Preis‑Leistungs‑Verhältnis, nachhaltige Verpackung ohne Plastik und Rücksendung gratis – top!",
        "date": "2025-04-05"
    },
    {
        "name": "Anouk Janssens",
        "rating": 5,
        "gender": "female",
        "review": "Ich liebe die liebevoll verpackten Sendungen: kaum Plastik, angenehmer Duft nach frischer Baumwolle.<br><strong>Pro:</strong> schnelle Updates zum Bestellstatus, gratis Retoure.<br><strong>Contra:</strong> Ein Shirt wirkte farblich anders als online, aber Umtausch war unkompliziert.",
        "date": "2025-04-07"
    },
    {
        "name": "Céline Giroux",
        "rating": 4,
        "gender": "female",
        "review": "<strong>Pluspunkte:</strong> Versand meist innerhalb von 48 h, ehrliche Made‑in‑Germany‑Qualität, kostenloser Rückversand!<br><strong>Minuspunkt:</strong> Einmal hatte ich leichte Abweichungen bei der Stoffdicke – Support bot direkt Rabatt als Entschädigung.",
        "date": "2025-04-09"
    },
    {
        "name": "Zuzanna Novak",
        "rating": 5,
        "gender": "female",
        "review": "Vom ersten Klick bis zum Auspacken fühlt man sich hier wertgeschätzt: Tracking‑Mails halten mich laufend auf dem Laufenden, das Paket kommt in recyceltem Karton mit handgeschriebener Karte – Herzklopfen!<br><strong>Details:</strong> 3 Teile bestellt, 2 Tage Lieferzeit, alle Nähte sauber, Farben strahlend wie auf den Bildern.<br><strong>Fazit:</strong> Toller Shop, faire Preise, klare Empfehlung.",
        "date": "2025-04-11"
    },
    {
        "name": "Maija Virtanen",
        "rating": 5,
        "gender": "female",
        "review": "Achtung vor den Copycat‑Händlern auf Insta & Temu! Wer echte Qualität will, bestellt hier: nachhaltige Stoffe, gratis Retoure und bei Lieferverzug gabs für mich sogar 20 % Rabatt PLUS Ware behalten – Servicelevel, das man heutzutage kaum noch findet.",
        "date": "2025-04-13"
    },
    {
        "name": "Inês Costa",
        "rating": 4,
        "gender": "female",
        "review": "<strong>Erster Eindruck:</strong> Übersichtlich gestalteter Shop, breite Größenauswahl.<br><strong>Versand & Verpackung:</strong> Bestellung Montag – Zustellung Donnerstag; Karton plastikfrei, Kleidungsstücke in dünnem Papier eingeschlagen.<br><strong>Kundendienst:</strong> Rückfrage zur Passform wurde binnen 30 Min. beantwortet, super freundlich.<br><strong>Pro:</strong> gratis Rücksendung, faire Preise, soziale Verantwortung.<br><strong>Contra:</strong> Ein Pullover roch leicht nach Lager, verflog aber nach erstem Waschen.<br><strong>Gesamt:</strong> 4/5 Sterne – werde definitiv wieder bestellen.",
        "date": "2025-04-14"
    },
    {
        "name": "Sofia van Dijk",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Story‑Time:</strong> Mein Paket hing wegen DHL‑Streik fest; nach Anfrage bot man mir wahlweise Sofort‑Erstattung oder 100 % Rabatt auf nächste Bestellung – ich durfte die Ware sogar behalten!<br><strong>Made‑in‑Germany‑Qualität:</strong> Säume perfekt vernäht, Stoff angenehm auf der Haut.<br><strong>Empfehlung:</strong> Finger weg von den Fake‑Shops, hier bekommt ihr echte, langlebige Teile ohne Mikroplastik‑Schock.",
        "date": "2025-04-16"
    },
    {
        "name": "Elodie Dubois",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Ode an bewussten Konsum:</strong> In einer Welt des Wegwerf‑Textils erblüht dieser Shop wie eine seltene Blume – kurzer Lieferweg, recycelte Verpackung und Designs, die nicht von Fast‑Fashion‑Giganten kopiert, sondern umgekehrt plagiiert werden.<br><strong>Erlebnis:</strong> Fünf Teile bestellt – jedes Einzelne fühlte sich an, als wäre es eigens für mich gefertigt worden; selbst die Papierbänder tragen kleine, handschriftliche Botschaften.<br><strong>Service‑Paradebeispiel:</strong> Größenumtausch in unter 72 h inkl. persönlicher Styling‑Empfehlung, kostenlos.<br><strong>Bottom Line:</strong> Wenn Nachhaltigkeit, Stil und Fairness einen ballettgleichen Pas de Trois tanzen, dann hier – mein Kleiderschrank verneigt sich.",
        "date": "2025-04-18"
    },



    {
        "name": "Olivia Schäfer",
        "rating": 5,
        "gender": "female",
        "review": "Schneller Versand, alles super.",
        "date": "2025-04-05"
    },
    {
        "name": "Zuzanna Delgado",
        "rating": 4,
        "gender": "female",
        "review": "Bestellung war nach 4 Tagen da. Farbe wie abgebildet, Stoff angenehm.",
        "date": "2025-04-01"
    },
    {
        "name": "Ilaria Kowalczyk",
        "rating": 5,
        "gender": "female",
        "review": "Trotz Feiertag nur 3 Tage gewartet. Kundendienst war wie immer top. Nachhaltige Verpackung ohne Plastik.",
        "date": "2025-04-04"
    },
    {
        "name": "Chiara Janssens",
        "rating": 5,
        "gender": "female",
        "review": "Versandzeit betrug diesmal 5 Tage, voll okay.<br><strong>Pro:</strong> Stoff fühlt sich robust an; Päckchen kam plastikfrei und liebevoll verpackt.<br><strong>Contra:</strong> Farbe leicht abweichend, aber Gratis Rücksendung erspart Ärger",
        "date": "2025-04-14"
    },
    {
        "name": "Małgorzata Giroux",
        "rating": 4,
        "gender": "female",
        "review": "Farbe wie abgebildet, Stoff angenehm; Lieferung kam in nur 2 Tagen.<br>Habe sofort Updates zum Bestellstatus erhalten – Kostenlose Retoure ist heutzutage selten",
        "date": "2025-04-13"
    },
    {
        "name": "Anna Novak",
        "rating": 5,
        "gender": "female",
        "review": "Päckchen kam plastikfrei und liebevoll verpackt.<br>Trotz Feiertag nur 3 Tage gewartet.<br><strong>Service:</strong> Habe sofort Updates zum Bestellstatus erhalten.<br><strong>Fazit:</strong> Werde wieder bestellen.",
        "date": "2025-04-16"
    },
    {
        "name": "Greta Virtanen",
        "rating": 5,
        "gender": "female",
        "review": "Support antwortet blitzschnell.<br>Lieferung kam in nur 2 Tagen.<br>Qualität wirkt hochwertig.<br>Rückgabe lief schnell und kostenlos.<br><strong>Tipp:</strong> Passt auf die ganzen Fake‑Shops auf – hier bekommt ihr das Original!",
        "date": "2025-04-17"
    },
    {
        "name": "Helena Costa",
        "rating": 5,
        "gender": "female",
        "review": "Ich bin begeistert: Farbe wie abgebildet, Stoff angenehm.<br>Päckchen kam plastikfrei und liebevoll verpackt.<br>Versandzeit betrug diesmal 5 Tage, voll okay.<br>Kundendienst war wie immer top.<br><strong>Plus:</strong> Umtausch wegen Größe war total easy.<br><strong>Hinweis:</strong> Man spürt die Made‑in‑Germany‑Qualität.",
        "date": "2025-04-11"
    },
    {
        "name": "Rianne van Dijk",
        "rating": 4,
        "gender": "female",
        "review": "<strong>Erlebnisbericht:</strong> Beim letzten Mal gab’s sogar Rabatt, weil DHL trödelte.<br>Schönes Papier statt Folie – gefällt mir.<br>Lieferung kam in nur 2 Tagen.<br>Nähte sauber verarbeitet.<br><strong>Service‑Highlight:</strong> Support antwortet blitzschnell; Rückgabe lief schnell und kostenlos.<br><strong>Warnung:</strong> Passt auf die ganzen Fake‑Shops auf – hier bekommt ihr das Original!",
        "date": "2025-04-12"
    },
    {
        "name": "Noor Dubois",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Langfassung:</strong> In Zeiten, in denen Asos & Co. Rücksendekosten verlangen, zeigt dieses Unternehmen, wie Kundenorientierung geht.<br>Kaum Müll dank Recyclingkarton.<br>Bestellung war nach 4 Tagen da.<br>Nähte sauber verarbeitet – und falls mal was nicht passt: Rückgabe lief schnell und kostenlos.<br>Man spürt die Made‑in‑Germany‑Qualität.<br>Ich habe vier Teile behalten, eins zurück – dank gratis Retoure kein Stress.<br>Passt auf die ganzen Fake‑Shops auf – hier bekommt ihr das Original!<br><strong>Fazit:</strong> Nachhaltig, fair, zuverlässig – hier kauft man mit gutem Gefühl.",
        "date": "2025-04-18"
    },
    {
        "name": "Sofie Bauer",
        "rating": 5,
        "gender": "female",
        "review": "Schneller Versand, alles super.",
        "date": "2025-04-08"
    },
    {
        "name": "Ada Fernández",
        "rating": 4,
        "gender": "female",
        "review": "Lieferung kam in nur 2 Tagen. Stoff fühlt sich robust an.",
        "date": "2025-04-06"
    },
    {
        "name": "Eeva Nowak",
        "rating": 5,
        "gender": "female",
        "review": "Bestellung war nach 4 Tagen da. Kundendienst war wie immer top. Sch&ouml;nes Papier statt Folie – gefällt mir.",
        "date": "2025-04-03"
    },
    {
        "name": "Nina Vermeulen",
        "rating": 5,
        "gender": "female",
        "review": "Versandzeit betrug diesmal 5 Tage, voll okay.<br><strong>Pro:</strong> Farbe wie abgebildet, Stoff angenehm; Kaum Müll dank Recyclingkarton.<br><strong>Contra:</strong> Farbe leicht abweichend, aber Umtausch wegen Größe war total easy",
        "date": "2025-04-09"
    },
    {
        "name": "Franziska Leroux",
        "rating": 4,
        "gender": "female",
        "review": "Stoff fühlt sich robust an; Lieferung kam in nur 2 Tagen.<br>Support antwortet blitzschnell – Kostenlose Retoure ist heutzutage selten",
        "date": "2025-04-10"
    },
    {
        "name": "Lucía Kaczmarek",
        "rating": 5,
        "gender": "female",
        "review": "Schönes Papier statt Folie – gefällt mir.<br>Trotz Feiertag nur 3 Tage gewartet.<br><strong>Service:</strong> Kundendienst war wie immer top.<br><strong>Fazit:</strong> Werde wieder bestellen.",
        "date": "2025-04-02"
    },
    {
        "name": "Veronika Svensson",
        "rating": 5,
        "gender": "female",
        "review": "Kundendienst war wie immer top.<br>Lieferung kam in nur 2 Tagen.<br>Nähte sauber verarbeitet.<br>Gratis Rücksendung erspart Ärger.<br><strong>Tipp:</strong> Passt auf die ganzen Fake‑Shops auf – hier bekommt ihr das Original!",
        "date": "2025-04-15"
    },
    {
        "name": "Beatriz Martínez",
        "rating": 5,
        "gender": "female",
        "review": "Ich bin begeistert: Stoff fühlt sich robust an.<br>Päckchen kam plastikfrei und liebevoll verpackt.<br>Versandzeit betrug diesmal 5 Tage, voll okay.<br>Habe sofort Updates zum Bestellstatus erhalten.<br><strong>Plus:</strong> Rückgabe lief schnell und kostenlos.<br><strong>Hinweis:</strong> Man spürt die Made‑in‑Germany‑Qualität.",
        "date": "2025-04-05"
    },
    {
        "name": "Marta Smits",
        "rating": 4,
        "gender": "female",
        "review": "<strong>Erlebnisbericht:</strong> Beim letzten Mal gab’s sogar Rabatt, weil DHL trödelte.<br>Päckchen kam plastikfrei und liebevoll verpackt.<br>Trotz Feiertag nur 3 Tage gewartet.<br>Qualität wirkt hochwertig.<br><strong>Service‑Highlight:</strong> Support antwortet blitzschnell; Umtausch wegen Größe war total easy.<br><strong>Warnung:</strong> Passt auf die ganzen Fake‑Shops auf – hier bekommt ihr das Original!",
        "date": "2025-04-07"
    },
    {
        "name": "Silke Hämäläinen",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Langfassung:</strong> In Zeiten, in denen H&M Rücksendekosten verlangen, zeigt dieses Unternehmen, wie Kundenorientierung geht.<br>Kaum Müll dank Recyclingkarton.<br>Bestellung war nach 4 Tagen da.<br>Nähte sauber verarbeitet – und falls mal was nicht passt: Rückgabe lief schnell und kostenlos.<br>Man spürt die Made‑in‑Germany‑Qualität.<br>Ich habe vier Teile behalten, eins zurück – dank gratis Retoure kein Stress.<br>Passt auf die ganzen Fake‑Shops auf – hier bekommt ihr das Original!<br><strong>Fazit:</strong> Nachhaltig, fair, zuverlässig – hier kauft man mit gutem Gefühl.",
        "date": "2025-04-11"
    },
    {
        "name": "Helmi Bianchi",
        "rating": 5,
        "gender": "female",
        "review": "Schneller Versand, alles super.",
        "date": "2025-04-01"
    },
    {
        "name": "Agata Ivanova",
        "rating": 4,
        "gender": "female",
        "review": "Trotz Feiertag nur 3 Tage gewartet. Nähte sauber verarbeitet.",
        "date": "2025-04-06"
    },
    {
        "name": "Tamara Garcia",
        "rating": 5,
        "gender": "female",
        "review": "Bestellung war nach 4 Tagen da. Habe sofort Updates zum Bestellstatus erhalten. Kaum Müll dank Recyclingkarton.",
        "date": "2025-04-03"
    },
    {
        "name": "Anouk Van der Meer",
        "rating": 5,
        "gender": "female",
        "review": "Versandzeit betrug diesmal 5 Tage, voll okay.<br><strong>Pro:</strong> Stoff fühlt sich robust an; Schönes Papier statt Folie – gefällt mir.<br><strong>Contra:</strong> Farbe leicht abweichend, aber Gratis Rücksendung erspart Ärger",
        "date": "2025-04-12"
    },
    {
        "name": "Petra Korhonen",
        "rating": 4,
        "gender": "female",
        "review": "Farbe wie abgebildet, Stoff angenehm; Lieferung kam in nur 2 Tagen.<br>Der Kundenservice hält mich stets informiert – Rückgabe lief schnell und kostenlos",
        "date": "2025-04-13"
    },
    {
        "name": "Rosa Hoffmann",
        "rating": 5,
        "gender": "female",
        "review": "Schönes Papier statt Folie – gefällt mir.<br>Lieferung kam in nur 2 Tagen.<br><strong>Service:</strong> Support antwortet blitzschnell.<br><strong>Fazit:</strong> Werde wieder bestellen.",
        "date": "2025-04-14"
    },
    {
        "name": "Viviane Rodríguez",
        "rating": 5,
        "gender": "female",
        "review": "Kundendienst war wie immer top.<br>Versandzeit betrug diesmal 5 Tage, voll okay.<br>Stoff fühlt sich robust an.<br>Umtausch wegen Größe war total easy.<br><strong>Tipp:</strong> Passt auf die ganzen Fake‑Shops auf – hier bekommt ihr das Original!",
        "date": "2025-04-15"
    },
    {
        "name": "Katarzyna López",
        "rating": 5,
        "gender": "female",
        "review": "Ich bin begeistert: Nähte sauber verarbeitet.<br>Kaum Müll dank Recyclingkarton.<br>Lieferung kam in nur 2 Tagen.<br>Support antwortet blitzschnell.<br><strong>Plus:</strong> Rückgabe lief schnell und kostenlos.<br><strong>Hinweis:</strong> Man spürt die Made‑in‑Germany‑Qualität.",
        "date": "2025-04-16"
    },
    {
        "name": "Leena Müller",
        "rating": 4,
        "gender": "female",
        "review": "<strong>Erlebnisbericht:</strong> Beim letzten Mal gab’s sogar Rabatt, weil DHL trödelte.<br>Schönes Papier statt Folie – gefällt mir.<br>Bestellung war nach 4 Tagen da.<br>Qualität wirkt hochwertig.<br><strong>Service‑Highlight:</strong> Habe sofort Updates zum Bestellstatus erhalten; Gratis Rücksendung erspart Ärger.<br><strong>Warnung:</strong> Passt auf die ganzen Fake‑Shops auf – hier bekommt ihr das Original!",
        "date": "2025-04-17"
    },
    {
        "name": "Renée Nilsson",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Langfassung:</strong> In Zeiten, in denen Zara Rücksendekosten verlangt, zeigt dieses Unternehmen, wie Kundenorientierung geht.<br>Päckchen kam plastikfrei und liebevoll verpackt.<br>Trotz Feiertag nur 3 Tage gewartet.<br>Nähte sauber verarbeitet – und falls mal was nicht passt: Umtausch wegen Größe war total easy.<br>Man spürt die Made‑in‑Germany‑Qualität.<br>Ich habe vier Teile behalten, eins zurück – dank gratis Retoure kein Stress.<br>Passt auf die ganzen Fake‑Shops auf – hier bekommt ihr das Original!<br><strong>Fazit:</strong> Nachhaltig, fair, zuverlässig – hier kauft man mit gutem Gefühl.",
        "date": "2025-04-18"
    },
    {
        "name": "Isabelle Dupont",
        "rating": 5,
        "gender": "female",
        "review": "Schneller Versand, alles super.",
        "date": "2025-04-02"
    },
    {
        "name": "Laura Bergström",
        "rating": 4,
        "gender": "female",
        "review": "Bestellung war nach 4 Tagen da. Stoff fühlt sich robust an.",
        "date": "2025-04-05"
    },
    {
        "name": "Esmé Keller",
        "rating": 5,
        "gender": "female",
        "review": "Trotz Feiertag nur 3 Tage gewartet. Kundendienst war wie immer top. Nachhaltige Verpackung ohne Plastik.",
        "date": "2025-04-07"
    },
    {
        "name": "Helena Moreau",
        "rating": 5,
        "gender": "female",
        "review": "Versandzeit betrug diesmal 5 Tage, voll okay.<br><strong>Pro:</strong> Nähte sauber verarbeitet; Schönes Papier statt Folie – gefällt mir.<br><strong>Contra:</strong> Farbe leicht abweichend, aber Rückgabe lief schnell und kostenlos",
        "date": "2025-04-08"
    },
    {
        "name": "Sofia Silva",
        "rating": 4,
        "gender": "female",
        "review": "Farbe wie abgebildet, Stoff angenehm; Lieferung kam in nur 2 Tagen.<br>Support antwortet blitzschnell – Kostenlose Retoure ist heutzutage selten",
        "date": "2025-04-09"
    },
    {
        "name": "Helmi Kovačević",
        "rating": 5,
        "gender": "female",
        "review": "Kaum Müll dank Recyclingkarton.<br>Versandzeit betrug diesmal 5 Tage, voll okay.<br><strong>Service:</strong> Der Kundenservice hält mich stets informiert.<br><strong>Fazit:</strong> Werde wieder bestellen.",
        "date": "2025-04-10"
    },
    {
        "name": "Camille Fischer",
        "rating": 5,
        "gender": "female",
        "review": "Der Kundenservice hält mich stets informiert.<br>Lieferung kam in nur 2 Tagen.<br>Nähte sauber verarbeitet.<br>Rückgabe lief schnell und kostenlos.<br><strong>Tipp:</strong> Passt auf die ganzen Fake‑Shops auf – hier bekommt ihr das Original!",
        "date": "2025-04-11"
    },
    {
        "name": "Sofia Meier",
        "rating": 5,
        "gender": "female",
        "review": "Ich bin begeistert: Stoff fühlt sich robust an.<br>Nachhaltige Verpackung ohne Plastik.<br>Lieferung kam in nur 2 Tagen.<br>Support antwortet blitzschnell.<br><strong>Plus:</strong> Umtausch wegen Größe war total easy.<br><strong>Hinweis:</strong> Man spürt die Made‑in‑Germany‑Qualität.",
        "date": "2025-04-12"
    },
    {
        "name": "Maija Popescu",
        "rating": 4,
        "gender": "female",
        "review": "<strong>Erlebnisbericht:</strong> Beim letzten Mal gab’s sogar Rabatt, weil DHL trödelte.<br>Kaum Müll dank Recyclingkarton.<br>Bestellung war nach 4 Tagen da.<br>Qualität wirkt hochwertig.<br><strong>Service‑Highlight:</strong> Kundendienst war wie immer top; Rückgabe lief schnell und kostenlos.<br><strong>Warnung:</strong> Passt auf die ganzen Fake‑Shops auf – hier bekommt ihr das Original!",
        "date": "2025-04-13"
    },
    {
        "name": "Astrid Lindberg",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Langfassung:</strong> In Zeiten, in denen Temu Rücksendekosten verlangt, zeigt dieses Unternehmen, wie Kundenorientierung geht.<br>Päckchen kam plastikfrei und liebevoll verpackt.<br>Trotz Feiertag nur 3 Tage gewartet.<br>Farbe wie abgebildet, Stoff angenehm – und falls mal was nicht passt: Gratis Rücksendung erspart Ärger.<br>Man spürt die Made‑in‑Germany‑Qualität.<br>Ich habe vier Teile behalten, eins zurück – dank gratis Retoure kein Stress.<br>Passt auf die ganzen Fake‑Shops auf – hier bekommt ihr das Original!<br><strong>Fazit:</strong> Nachhaltig, fair, zuverlässig – hier kauft man mit gutem Gefühl.",
        "date": "2025-04-14"
    },
    {
        "name": "Ada Dröge",
        "rating": 5,
        "gender": "female",
        "review": "Schneller Versand, alles super.",
        "date": "2025-04-04"
    },
    {
        "name": "Milena Gomes",
        "rating": 4,
        "gender": "female",
        "review": "Bestellung war nach 4 Tagen da. Nähte sauber verarbeitet.",
        "date": "2025-04-06"
    },
    {
        "name": "Anna Weber",
        "rating": 5,
        "gender": "female",
        "review": "Trotz Feiertag nur 3 Tage gewartet. Der Kundenservice hält mich stets informiert. Kaum Müll dank Recyclingkarton.",
        "date": "2025-04-03"
    },
    {
        "name": "Xenia Lang",
        "rating": 5,
        "gender": "female",
        "review": "Versandzeit betrug diesmal 5 Tage, voll okay.<br><strong>Pro:</strong> Farbe wie abgebildet, Stoff angenehm; Nachhaltige Verpackung ohne Plastik.<br><strong>Contra:</strong> Farbe leicht abweichend, aber Rückgabe lief schnell und kostenlos",
        "date": "2025-04-05"
    },
    {
        "name": "Blanka Pavlova",
        "rating": 4,
        "gender": "female",
        "review": "Stoff fühlt sich robust an; Lieferung kam in nur 2 Tagen.<br>Support antwortet blitzschnell – Kostenlose Retoure ist heutzutage selten",
        "date": "2025-04-08"
    },
    {
        "name": "Dorota Peeters",
        "rating": 5,
        "gender": "female",
        "review": "Nachhaltige Verpackung ohne Plastik.<br>Bestellung war nach 4 Tagen da.<br><strong>Service:</strong> Habe sofort Updates zum Bestellstatus erhalten.<br><strong>Fazit:</strong> Werde wieder bestellen.",
        "date": "2025-04-10"
    },
    {
        "name": "Helmi Nieminen",
        "rating": 5,
        "gender": "female",
        "review": "Support antwortet blitzschnell.<br>Lieferung kam in nur 2 Tagen.<br>Qualität wirkt hochwertig.<br>Rückgabe lief schnell und kostenlos.<br><strong>Tipp:</strong> Passt auf die ganzen Fake‑Shops auf – hier bekommt ihr das Original!",
        "date": "2025-04-11"
    },
    {
        "name": "Natasha Tóth",
        "rating": 5,
        "gender": "female",
        "review": "Ich bin begeistert: Nähte sauber verarbeitet.<br>Päckchen kam plastikfrei und liebevoll verpackt.<br>Versandzeit betrug diesmal 5 Tage, voll okay.<br>Der Kundenservice hält mich stets informiert.<br><strong>Plus:</strong> Gratis Rücksendung erspart Ärger.<br><strong>Hinweis:</strong> Man spürt die Made‑in‑Germany‑Qualität.",
        "date": "2025-04-12"
    },
    {
        "name": "Sabine Seidel",
        "rating": 4,
        "gender": "female",
        "review": "<strong>Erlebnisbericht:</strong> Beim letzten Mal gab’s sogar Rabatt, weil DHL trödelte.<br>Nachhaltige Verpackung ohne Plastik.<br>Bestellung war nach 4 Tagen da.<br>Qualität wirkt hochwertig.<br><strong>Service‑Highlight:</strong> Support antwortet blitzschnell; Kostenlose Retoure ist heutzutage selten.<br><strong>Warnung:</strong> Passt auf die ganzen Fake‑Shops auf – hier bekommt ihr das Original!",
        "date": "2025-04-13"
    },
    {
        "name": "Tereza Gruber",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Langfassung:</strong> In Zeiten, in denen Fast‑Fashion‑Riesen Rücksendekosten verlangen, zeigt dieses Unternehmen, wie Kundenorientierung geht.<br>Päckchen kam plastikfrei und liebevoll verpackt.<br>Trotz Feiertag nur 3 Tage gewartet.<br>Stoff fühlt sich robust an – und falls mal was nicht passt: Umtausch wegen Größe war total easy.<br>Man spürt die Made‑in‑Germany‑Qualität.<br>Ich habe vier Teile behalten, eins zurück – dank gratis Retoure kein Stress.<br>Passt auf die ganzen Fake‑Shops auf – hier bekommt ihr das Original!<br><strong>Fazit:</strong> Nachhaltig, fair, zuverlässig – hier kauft man mit gutem Gefühl.",
        "date": "2025-04-14"
    },
  {
        "name": "Sofia Virtanen",
        "rating": 5,
        "gender": "female",
        "review": "Schneller Versand, alles super.",
        "date": "2025-04-05"
    },
    {
        "name": "Claudia Silva",
        "rating": 4,
        "gender": "female",
        "review": "Lieferung kam in nur 2 Tagen. Nähte sauber verarbeitet.",
        "date": "2025-04-07"
    },
    {
        "name": "Petra Hämäläinen",
        "rating": 5,
        "gender": "female",
        "review": "Trotz Feiertag nur 3 Tage gewartet. Support antwortet blitzschnell. Nachhaltige Verpackung ohne Plastik.",
        "date": "2025-04-11"
    },
    {
        "name": "Franziska Smits",
        "rating": 5,
        "gender": "female",
        "review": "Versandzeit betrug diesmal 5 Tage, voll okay.<br><strong>Pro:</strong> Qualität wirkt hochwertig.; Schönes Papier statt Folie – gefällt mir.<br><strong>Contra:</strong> Farbe leicht abweichend, aber Gratis Rücksendung erspart Ärger",
        "date": "2025-04-04"
    },
    {
        "name": "Ute Martínez",
        "rating": 4,
        "gender": "female",
        "review": "Bestellung war nach 4 Tagen da. Farbe wie abgebildet, Stoff angenehm.",
        "date": "2025-04-14"
    },
    {
        "name": "Chiara Rodríguez",
        "rating": 5,
        "gender": "female",
        "review": "Kaum Müll dank Recyclingkarton.<br>Lieferung kam in nur 2 Tagen.<br><strong>Service:</strong> Kundendienst war wie immer top.<br><strong>Fazit:</strong> Werde wieder bestellen.",
        "date": "2025-04-12"
    },
    {
        "name": "Viola van Dijk",
        "rating": 5,
        "gender": "female",
        "review": "Support antwortet blitzschnell.<br>Bestellung war nach 4 Tagen da.<br>Stoff fühlt sich robust an.<br>Umtausch wegen Größe war total easy.<br><strong>Tipp:</strong> Passt auf die ganzen Fake‑Shops auf – hier bekommt ihr das Original!",
        "date": "2025-04-17"
    },
    {
        "name": "Monika Teixeira",
        "rating": 4,
        "gender": "female",
        "review": "Ich bin begeistert: Nähte sauber verarbeitet.<br>Päckchen kam plastikfrei und liebevoll verpackt.<br>Versandzeit betrug diesmal 5 Tage, voll okay.<br>Der Kundenservice hält mich stets informiert.<br><strong>Plus:</strong> Rückgabe lief schnell und kostenlos.<br><strong>Hinweis:</strong> Man spürt die Made‑in‑Germany‑Qualität.",
        "date": "2025-04-08"
    },
    {
        "name": "Elsa Korhonen",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Erlebnisbericht:</strong> Beim letzten Mal gab’s sogar Rabatt, weil DHL trödelte.<br>Päckchen kam plastikfrei und liebevoll verpackt.<br>Lieferung kam in nur 2 Tagen.<br>Qualität wirkt hochwertig.<br><strong>Service‑Highlight:</strong> Der Kundenservice hält mich stets informiert; Rückgabe lief schnell und kostenlos.<br><strong>Warnung:</strong> Passt auf die ganzen Fake‑Shops auf – hier bekommt ihr das Original!",
        "date": "2025-04-06"
    },
    {
        "name": "Ester Pavlova",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Langfassung:</strong> In Zeiten, in denen Asos & Co. Rücksendekosten verlangen, zeigt dieses Unternehmen, wie Kundenorientierung geht.<br>Nachhaltige Verpackung ohne Plastik.<br>Trotz Feiertag nur 3 Tage gewartet.<br>Farbe wie abgebildet, Stoff angenehm – und falls mal was nicht passt: Kostenlose Retoure ist heutzutage selten.<br>Man spürt die Made‑in‑Germany‑Qualität.<br>Ich habe vier Teile behalten, eins zurück – dank gratis Retoure kein Stress.<br>Passt auf die ganzen Fake‑Shops auf – hier bekommt ihr das Original!<br><strong>Fazit:</strong> Nachhaltig, fair, zuverlässig – hier kauft man mit gutem Gefühl.",
        "date": "2025-04-18"
    },
    {
        "name": "Annika Müller",
        "rating": 5,
        "gender": "female",
        "review": "Schneller Versand, alles super.",
        "date": "2025-04-01"
    },
    {
        "name": "Barbara Schmidt",
        "rating": 4,
        "gender": "female",
        "review": "Lieferung kam in nur 2 Tagen. Farbe wie abgebildet, Stoff angenehm.",
        "date": "2025-04-03"
    },
    {
        "name": "Helena Olesen",
        "rating": 5,
        "gender": "female",
        "review": "Bestellung war nach 4 Tagen da. Support antwortet blitzschnell. Schönes Papier statt Folie – gefällt mir.",
        "date": "2025-04-11"
    },
    {
        "name": "Giulia Dupont",
        "rating": 5,
        "gender": "female",
        "review": "Versandzeit betrug diesmal 5 Tage, voll okay.<br><strong>Pro:</strong> Qualität wirkt hochwertig.; Kaum Müll dank Recyclingkarton.<br><strong>Contra:</strong> Farbe leicht abweichend, aber Umtausch wegen Größe war total easy",
        "date": "2025-04-10"
    },
    {
        "name": "Dagmar Laurent",
        "rating": 4,
        "gender": "female",
        "review": "Farbe wie abgebildet, Stoff angenehm.; Lieferung kam in nur 2 Tagen. Der Kundenservice hält mich stets informiert.",
        "date": "2025-04-13"
    },
    {
        "name": "Beatriz Abreu",
        "rating": 5,
        "gender": "female",
        "review": "Schönes Papier statt Folie – gefällt mir.<br>Lieferung kam in nur 2 Tagen.<br><strong>Service:</strong> Habe sofort Updates zum Bestellstatus erhalten.<br><strong>Fazit:</strong> Werde wieder bestellen.",
        "date": "2025-04-02"
    },
    {
        "name": "Helmi Faber",
        "rating": 5,
        "gender": "female",
        "review": "Kundendienst war wie immer top.<br>Versandzeit betrug diesmal 5 Tage, voll okay.<br>Nähte sauber verarbeitet.<br>Rückgabe lief schnell und kostenlos.<br><strong>Tipp:</strong> Passt auf die ganzen Fake‑Shops auf – hier bekommt ihr das Original!",
        "date": "2025-04-09"
    },
    {
        "name": "Yvonne Neumann",
        "rating": 5,
        "gender": "female",
        "review": "Ich bin begeistert: Farbe wie abgebildet, Stoff angenehm.<br>Schönes Papier statt Folie – gefällt mir.<br>Lieferung kam in nur 2 Tagen.<br>Habe sofort Updates zum Bestellstatus erhalten.<br><strong>Plus:</strong> Gratis Rücksendung erspart Ärger.<br><strong>Hinweis:</strong> Man spürt die Made‑in‑Germany‑Qualität.",
        "date": "2025-04-15"
    },
    {
        "name": "Tatjana Petrová",
        "rating": 4,
        "gender": "female",
        "review": "<strong>Erlebnisbericht:</strong> Beim letzten Mal gab’s sogar Rabatt, weil DHL trödelte.<br>Kaum Müll dank Recyclingkarton.<br>Trotz Feiertag nur 3 Tage gewartet.<br>Qualität wirkt hochwertig.<br><strong>Service‑Highlight:</strong> Kundendienst war wie immer top; Kostenlos ..."
        ,
        "date": "2025-04-06"
    },
    {
        "name": "Zoé Dumont",
        "rating": 5,
        "gender": "female",
        "review": "<strong>Langfassung:</strong> In Zeiten, in denen Temu Rücksendekosten verlangt, zeigt dieses Unternehmen, wie Kundenorientierung geht.<br>Päckchen kam plastikfrei und liebevoll verpackt.<br>Bestellung war nach 4 Tagen da.<br>Nähte sauber verarbeitet – und falls mal was nicht passt: Kostenlose Retoure ist heutzutage selten.<br>Man spürt die Made‑in‑Germany‑Qualität.<br>Ich habe vier Teile behalten, eins zurück – dank gratis Retoure kein Stress.<br>Passt auf die ganzen Fake‑Shops auf – hier bekommt ihr das Original!<br><strong>Fazit:</strong> Nachhaltig, fair, zuverlässig – hier kauft man mit gutem Gefühl.",
        "date": "2025-04-16"
    }

  
  
];
